// filename: useNotifyGtmAfterHydration.tsx
import { useEffect } from 'react';
import { notifyGtmAfterHydration } from '../helpers/gtmReadyAfterHydration';

export function useNotifyGtmAfterHydration(eventName = 'react_hydrated'): void {
    useEffect(() => {
        // Runs after initial client render/hydration
        // Will wait for phone numbers to be in DOM before firing
        notifyGtmAfterHydration(eventName);
        // No dependencies: fire once
    }, [eventName]);
}
